import React from "react";
import { Icon, IconButton, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";

export default function DevedorEmailSection({ values, setFieldValue, handleChange, errors, touched, isViewOnly, apenasValidos = true }) {
    const visibleEmails = values.emails.filter(item => !(apenasValidos && (item.cbRuim || item.cbBlackList)));
    const hiddenCount = values.emails.length - visibleEmails.length;

    return (
        <MDBox mt={2}>
            <FieldArray name="emails">
                {({ push, remove }) => (
                    <>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1} flexWrap="wrap" gap={1}>
                            <MDBox display="flex" alignItems="center" gap={1}>
                                <MDTypography variant="button" fontWeight="bold" color="text">
                                    E-MAILS ({visibleEmails.length}{hiddenCount > 0 ? ` de ${values.emails.length}` : ""})
                                </MDTypography>
                                {hiddenCount > 0 && apenasValidos && (
                                    <MDTypography variant="caption" color="warning" sx={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                                        ({hiddenCount} inválido{hiddenCount > 1 ? "s" : ""} oculto{hiddenCount > 1 ? "s" : ""})
                                    </MDTypography>
                                )}
                            </MDBox>
                            <MDButton variant="contained" color="info" size="small" onClick={() => push({ ccEmail: '', cvOrigem: 4, cbRuim: false, cbBlackList: false })}>
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar E-mail
                            </MDButton>
                        </MDBox>
                        {values.emails.length > 0 && (
                            <TableContainer sx={{ boxShadow: "none" }}>
                                <Table>
                                    <MDBox component="thead">
                                        <TableRow>
                                            <DataTableHeadCell width="50%" sorted={false}>E-MAIL</DataTableHeadCell>
                                            <DataTableHeadCell width="26%" sorted={false}>ORIGEM</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>RUIM</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>BLACKLIST</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>AÇÕES</DataTableHeadCell>
                                        </TableRow>
                                    </MDBox>
                                    <TableBody>
                                        {values.emails.map((item, index) => {
                                            const isInvalid = Boolean(item.cbRuim || item.cbBlackList);
                                            if (apenasValidos && isInvalid) return null;

                                            return (
                                                <TableRow key={index} sx={isInvalid ? { opacity: 0.6 } : {}}>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            fullWidth 
                                                            size="small"
                                                            name={`emails[${index}].ccEmail`}
                                                            value={values.emails[index].ccEmail} 
                                                            onChange={handleChange} 
                                                            placeholder="exemplo@email.com"
                                                            autoComplete="off"
                                                            error={errors?.emails?.[index]?.ccEmail && touched?.emails?.[index]?.ccEmail}
                                                        />
                                                        {errors?.emails?.[index]?.ccEmail && touched?.emails?.[index]?.ccEmail && (
                                                            <MDTypography variant="caption" color="error">{errors.emails[index].ccEmail}</MDTypography>
                                                        )}
                                                        {/* Por que está ruim (ex.: voltou da Mala Direta); desmarcar "Ruim" e salvar apaga o motivo */}
                                                        {item.cbRuim && item.ccMotivoRuim && (
                                                            <MDTypography variant="caption" color="text" display="block" sx={{ px: 1, mt: 0.5 }}>
                                                                {item.ccMotivoRuim}
                                                            </MDTypography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            select 
                                                            fullWidth 
                                                            size="small"
                                                            name={`emails[${index}].cvOrigem`}
                                                            value={values.emails[index].cvOrigem} 
                                                            onChange={handleChange}
                                                        >
                                                            <MenuItem value={1}>Serasa</MenuItem>
                                                            <MenuItem value={2}>Boa Vista</MenuItem>
                                                            <MenuItem value={3}>Cliente</MenuItem>
                                                            <MenuItem value={4}>Informado</MenuItem>
                                                            <MenuItem value={5}>Outros</MenuItem>
                                                            <MenuItem value={6}>Remessa</MenuItem>
                                                        </MDInput>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <Switch 
                                                                checked={values.emails[index].cbRuim} 
                                                                onChange={(e) => setFieldValue(`emails[${index}].cbRuim`, e.target.checked)} 
                                                            />
                                                        </MDBox>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <Switch 
                                                                checked={values.emails[index].cbBlackList} 
                                                                onChange={(e) => setFieldValue(`emails[${index}].cbBlackList`, e.target.checked)} 
                                                                color="error" 
                                                            />
                                                        </MDBox>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <IconButton color="error" size="small" onClick={() => remove(index)}>
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </MDBox>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        {values.emails.length > 0 && visibleEmails.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ py: 2 }}>
                                                    <MDTypography variant="caption" color="text">
                                                        Todos os {values.emails.length} e-mails cadastrados estão marcados como Ruim ou Blacklist (ocultos pelo filtro).
                                                    </MDTypography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </FieldArray>
        </MDBox>
    );
}
